
export enum SystemRoles {
    Administrator = "Admin",
}
